<div class="md-stepper-horizontal">
  <div *ngFor="let item of [].constructor(totalSteps); let i = index;" class="md-step"
    [ngClass]="{'active': i === activeStep, 'success': i < activeStep}" (click)="stepperClicked.emit(i)">
    <div class="md-step-circle"><span></span></div>
    <div class="md-step-bar-left" [ngClass]="{'completed': i === activeStep || i < activeStep}"></div>
    <div class="md-step-bar-right" [ngClass]="{'completed': i < activeStep}"></div>
  </div>
</div>